export enum SalesManagoTag {
    HOME_PAGE = 'HOME_PAGE',
    CHECKOUT_FORM = 'formularz_rezerwacja_obiektu',
}
